import React, { Component } from 'react';

class SectionTitle extends Component {
  render() {
    return (
      <h2 className="section-title"><span>{this.props.title}</span>{this.props.children}</h2>
    );
  }
}
export default SectionTitle;